export default __webpack_public_path__ + "static/media/prosper-medical-bill-saver.b0e6cbf4.svg";